import { ChevronDown, History, SquarePen } from 'lucide-react';
import { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import Button from '@/components/Button/Button';
import Dropdown from '@/components/Dropdown/Dropdown';
import AMP_KEYS from '@/configs/amp-track-keys';
import useModalState from '@/hooks/pure/useModalState';
import { track } from '@/utils/track/track';

import { useHeySynclyPageStore } from '../model/hey-syncly-page-store';
import { HistoryPanel } from '../ui/history-panel/history-panel';

export const HeySynclyChatLayout = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const ref = useRef<HTMLButtonElement>(null);
  const [searchParams] = useSearchParams();
  const historyModal = useModalState();
  const onNewChat = useHeySynclyPageStore((state) => state.onNewChat);
  const hasChatId = Boolean(searchParams.get('chat_id'));

  const handleNewChat = () => {
    void track(AMP_KEYS.HEY_SYNCLY_NEW_CHAT_CLICK);
    onNewChat();
  };

  return (
    <>
      <div className="w-full flex justify-between items-center p-5 z-10 bg-white">
        <div className="flex items-center gap-1">
          <Button
            onClick={() => historyModal.open()}
            variant="ghost"
            sizeType="m"
            ref={ref}
            leftIcon={<History />}
            rightIcon={<ChevronDown />}
            className="max-w-fit w-full"
          />
        </div>

        {hasChatId && (
          <div className="flex items-center gap-1">
            <Button
              onClick={handleNewChat}
              variant="ghost"
              sizeType="m"
              leftIcon={<SquarePen />}
            >
              New
            </Button>
          </div>
        )}
      </div>

      {children}

      <Dropdown
        status={historyModal.status}
        close={historyModal.close}
        triggerEl={ref.current}
        modalWidth="400px"
        modalOptions={{
          offset: {
            y: 8,
          },
        }}
      >
        <HistoryPanel />
      </Dropdown>
    </>
  );
};
